export const INITIALIZE = 'BUDGET_EDITOR/INITIALIZE'
export const SET_ROWS = 'BUDGET_EDITOR/SET_ROWS'
export const UPDATE_ROW = 'BUDGET_EDITOR/UPDATE_ROW'
export const UPDATE_ROWS_STATE = 'BUDGET_EDITOR/UPDATE_ROWS_STATE'
export const SUBMIT = 'BUDGET_EDITOR/SUBMIT'

export const MODIFY_BUDGETS_BY_RULE = 'BUDGET_EDITOR/MODIFY_BUDGETS_BY_RULE'
export const MODIFY_DATES = 'BUDGET_EDITOR/MODIFY_DATES'
